<script setup>
defineProps({
    message: String,
    asHtml: Boolean,
});
</script>

<template>
    <div v-show="message">
        <p
            v-if="!asHtml"
            class="text-sm text-red-600"
        >
            {{ message }}
        </p>
        <p
            v-if="asHtml === true"
            class="text-sm text-red-600"
            v-html="message"
        ></p>
    </div>
</template>
